import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectors } from 'lib/entities/livestream';
import Image from 'global/Image';
import { ButtonSubmitQuestion, InputGroup, Label, Modal, ModalQuestionContent, Textarea } from '../styled';
import QuestionResultStatus from './QuestionResulStatus';
import LivestreamQuestionAnalytics from '../analytics/Question';

interface ModalQuestionProps {
  visible: boolean;
  onCancel: () => any;
  onSubmit: (val: string) => any;
}

function ModalQuestion({ visible, onCancel, onSubmit }: ModalQuestionProps) {
  const { writeQuestions: { isLoading, error } } = useSelector(selectors);
  const [isSubmit, setIsSubmit] = useState(false);
  const [question, setQuestion] = useState('');
  const [isResult, setIsResult] = useState(false);
  const matchMaxChar = question.length > 280;
  const isDisabled = matchMaxChar || question.length === 0;

  const onSubmitQuestion = async () => {
    setIsSubmit(true);

    const submit = await onSubmit(question);
    setIsResult(true);

    if (submit) {
      setTimeout(() => {
        onCancel();
        setQuestion('');
        setIsSubmit(false);
      }, 3000);
    }
  };

  const onChangeQuestion = (e) => {
    setQuestion(e.target.value);
    LivestreamQuestionAnalytics.Action.questionFilled();
  };

  useEffect(() => {
    setIsResult(false);
  }, [visible]);

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      centered
      footer={null}
      title={(
        <Text size="18px" family="bold" align="center">
          Questions
        </Text>
        )}
      width={430}
      isResult={isResult}
      destroyOnClose
      closeIcon={<Image src="/icon/close.svg" width="12" height="12" />}
      wrapClassName="livestream-modal-question"
    >
      {isSubmit && !isLoading ?
        <QuestionResultStatus status={!error ? 'success' : 'error'} />
        : (
          <ModalQuestionContent>
            <InputGroup>
              <Textarea
                // @ts-expect-error
                width="360px"
                onChange={onChangeQuestion}
                value={question}
                matchMaxChar={matchMaxChar}
                id="livestream-modal-question-input"
              />
              <Label
                color={matchMaxChar ? color.sunsetOrange : color.midgray}
                // @ts-expect-error
                status="error"
              >Question
              </Label>
              <Text
                align="right"
                size="12px"
                height="16px"
                // @ts-expect-error
                mt="4px"
                color={matchMaxChar ? color.sunsetOrange : color.midgray}
              >
                {question.length} / 280
              </Text>
            </InputGroup>
            <ButtonSubmitQuestion
              disabled={isDisabled}
              onClick={onSubmitQuestion}
              loading={isLoading}
              id="livestream-modal-question-submit"
            >
              Submit
            </ButtonSubmitQuestion>
          </ModalQuestionContent>
        )}
    </Modal>
  );
}

export default ModalQuestion;
